import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil'
import './css/App.less';
// import 'antd/dist/antd.css';
import './css/index.css'

import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
